import styles from "./AppBar.module.css";
import { useState, useEffect, useRef } from "react";
import logoImage from "../../assets/icons/logo.png";
import darkLogo from "../../assets/icons/dark-mode-logo.png";
import avatarImage from "../../assets/icons/avatar.png";
import ThemeSwitch from "../ThemeSwitch/ThemeSwitch";
import { useNavigate } from "react-router-dom";
import useAuthStore from "../../store/authStore";
import useDashboardStore from "../../store/dashboardStore";

const AppBar = ({ user }) => {
  const { setIsMyProfileScreen, setIsMyMembershipScreen } = useDashboardStore();
  const { logout, userMeta } = useAuthStore();
  const navigate = useNavigate();
  const [openMenu, setOpenMenu] = useState(false);
  const [theme, setTheme] = useState(localStorage.getItem("theme") || "light");
  const menuRef = useRef(null);

  const toggleTheme = () => {
    const next = theme === "light" ? "dark" : "light";
    setTheme(next);
    document.documentElement.setAttribute("data-theme", next);
    localStorage.setItem("theme", next);
  };

  // Close menu on outside click
  useEffect(() => {
    function handleClickOutside(e) {
      if (menuRef.current && !menuRef.current.contains(e.target)) {
        setOpenMenu(false);
      }
    }
    if (openMenu) {
      document.addEventListener("mousedown", handleClickOutside);
    }
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [openMenu]);

  // Get profile picture from userMeta
  const profilePicture = userMeta?.profile_picture_url || avatarImage;

  return (
    <div className={styles.appBar}>
      <img
        src={theme === "light" ? logoImage : darkLogo}
        className={styles.logo}
        alt="logo"
      />

      <div className={styles.actions}>
        <ThemeSwitch theme={theme} toggleTheme={toggleTheme} />

        <div className={styles.profileSection}>
          <div
            onClick={() => setOpenMenu(!openMenu)}
            className={styles.profileInfo}
          >
            {/* 🆕 Use profilePicture with fallback */}
            <img
              src={profilePicture}
              className={styles.avatar}
              alt="user"
              onError={(e) => {
                e.target.src = avatarImage; // Fallback if image fails to load
              }}
            />
            <div className={styles.userInfo}>
              <span>Hello</span>
              <strong>{user?.display_name || user?.first_name}</strong>
            </div>
            <span className={styles.dropdownArrow}>▾</span>
          </div>

          {openMenu && (
            <div className={styles.dropdownMenu} ref={menuRef}>
              <p>
                <strong>
                  {user?.first_name} {user?.last_name}
                </strong>
              </p>
              <p className={styles.role}>{user?.roles[0]}</p>
              <p className={styles.email}>{user?.email}</p>
              <hr />
              <p onClick={() => setIsMyProfileScreen()}>My Profile</p>
              <p onClick={() => setIsMyMembershipScreen()}>My Subscription</p>
              <p
                className={styles.signOut}
                onClick={() => {
                  logout();
                  navigate("/");
                }}
              >
                Sign Out
              </p>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default AppBar;
